import React from 'react' 
import IScalarForm from '../interface/IScalarForm'
import Scalar from './Scalar'
import { Button, Tag } from '@blueprintjs/core'
import { __ } from '@libs/utilities'

const ImageRadio = ( props: IScalarForm ): JSX.Element => {
    return <Scalar 
        { ...props } 
        enabledForm={<ImageRadioEnabled {...props} />}
        desabledForm={<ImageRadioDisabled {...props} />}
    /> 
} 

export default ImageRadio

const ImageRadioEnabled  = ( props: IScalarForm ): JSX.Element => {
    const _value = typeof (props.value || props.default ) === "object" 
        ? 
        (props.value || props.default )
        : 
        {
            _id: (props.value || props.default ),
            title: (props.value || props.default ),
            img: "",
            height: 45
        } 
    const onClick = ( i:number) => {
        const v = [ ...props.values || [] ].filter((val, n) => n === i)[0]
        if( props.onChange && v ) {
            props.onChange(
                v._id ? v._id : v, 
                props.field, 
                ""
            )
        }
    }
    return <div className="d-flex flex-wrap align-items-start">
        {
            props.values?.map((value, i) => {
                const checked = Array.isArray( _value )
                    ?
                    !!_value.filter( v => v === value._id ).length
                    :
                    value._id === _value._id
                return <Button
                    key={i}
                    role="button"
                    className="scalar-imgage-radio-label"
                    onClick={( ) => onClick( i )}
                    data-v={ value._id }
                    variant={ !checked ? "minimal": "solid" }
                >
                    <div 
                        style={{ 
                            minWidth: value.width || props.width, 
                            display: 'flex', 
                            flexDirection: 'column',
                            justifyContent: 'center',
                            padding: value.padding 
                        }}
                    >
                        <img
                            src={ value.img }
                            alt={ "" }
                            className="scalar-imgage-radio-img"
                            style={{
                                height: value.height,
                                top: 0,
                                opacity: checked
                                    ? 
                                    value.icon_opacity
                                        ? 
                                        value.icon_opacity
                                        : 
                                        1
                                    : 
                                    0.125,
                            }}
                        />
                        <div className="scalar-imgage-radio-title text-center" style={{...props.style, maxWidth: value.width || props.width}}>
                            { __(value.title) }
                        </div>
                        {/* <div 
                            className="scalar-imgage-radio-description text-center" 
                            style={{maxWidth: value.width || props.width}}
                        >
                            { __(value.description) }
                        </div> */}
                    </div>
                </Button>
            })
        }
        {
            !!_value 
                ?
                Array.isArray( _value )
                    ?
                    !!_value.map(v => {
                        return <div key={ v._id } className='w-100'>
                            {/* <div className='mt-1title text-center w-100'>{__( typeof v === "string" ? v : v.title )} </div> */}
                            <div className='mb-1 small text-center w-100'>{__( typeof v === "string" ? "" : v.description )} </div>
                        </div>
                    })
                    :
                    <div className='w-100 m-3'>
                        {/* <div className=' text-center title w-100'>{__(  typeof _value === "string" ? _value : _value.title )}</div> */}
                        {
                            (props.values || [])
                            .filter(val => val._id === ( typeof _value === "string" ? _value : _value._id ) )
                            .map(v => {
                                return <div className=' text-center small w-100' key={ v._id }>{ __(  typeof v === "string" ? "" : v.description ) } </div>
                            }) 
                        }
                    </div>
                :
                <></>
        }    
    </div>
}
const ImageRadioDisabled  = ( props: IScalarForm ): JSX.Element => {
    const checkedValue = props.values?.filter( v => v._id === props.value )[0]
    const _value = typeof (props.value || props.default ) === "object" 
        ? 
        (props.value || props.default )
        : 
        {
            _id: (props.value || props.default ),
            title: (props.value || props.default ),
            img: "",
            height: 45
        } 
    return checkedValue
        ?
        <div>
            <img
                src={checkedValue.img}
                alt={_value.title}
                className="scalar-imgage-radio-img"
                style={{
                    height: checkedValue.height,
                    top: 0 
                }}
            />
            <div>{ _value.title }</div>
        </div>
        :
        <Tag>
            { _value.title }
        </Tag>
}